import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import {
  Africa,
  Australia,
  Caribbean,
  Dubai,
  EastAsia,
  Europe,
  IndiaOcean,
  NorthAmerica,
  Polar,
  South,
} from './Menus';
import { colors } from '../styles/colors';
import { MenuOverlay } from './MenuOverlay';
import { useDispatch } from 'react-redux';
import { setDestinations } from '../features/destination/destinationSlice';
import { countries } from '../constants/menuItems';

const data = [
  {
    name: 'Africa',
    component: <Africa />,
    isName: true,
    index: 1,
    menus: countries.africa,
  },
  {
    name: 'Australia/NZ/Pacific',
    component: <Australia />,
    isName: true,
    index: 2,
    menus: countries.australia,
  },
  {
    name: 'Caribbean',
    component: <Caribbean />,
    isName: true,
    index: 3,
    menus: countries.caribbean,
  },
  {
    name: 'Dubai & Middle East',
    component: <Dubai />,
    isName: true,
    index: 4,
    menus: countries.middleEast,
  },
  {
    name: 'Europe',
    component: <Europe />,
    isName: true,
    index: 5,
    menus: countries.europe,
  },
  {
    name: 'Far East & Asia',
    component: <EastAsia />,
    isName: true,
    index: 6,
    menus: countries.farEast,
  },
  {
    name: 'Indian Ocean',
    component: <IndiaOcean />,
    isName: true,
    index: 7,
    menus: countries.indiaOcean,
  },
  {
    name: 'North America',
    component: <NorthAmerica />,
    isName: true,
    index: 8,
    menus: countries.northAmerica,
  },
  {
    name: 'Polar',
    component: <Polar />,
    isName: true,
    index: 9,
    menus: countries.polar,
  },
  {
    name: 'South & Central America',
    component: <South />,
    isName: true,
    index: 10,
    menus: countries.southCentralAmerica,
  },
];

export const Destinations = () => {
  //! Hooks
  const [currentIndex, setCurrentIndex] = useState<number>(null || 3);

  //! variables
  const dispatch = useDispatch();

  //! Functions
  const handleContinentClick = (item: any) => {
    setCurrentIndex(item.index);
    dispatch(setDestinations(item.menus));
  };

  return (
    <>
      <MenuOverlay>
        <Box
          sx={{
            display: 'flex',
            '& button': {
              p: 0,
              height: '40px',
              justifyContent: 'start',
              width: '100%',
              pl: 1,
              maxHeight: '625px',
              borderTopLeftRadius: '2px',
              borderBottomLeftRadius: '2px',
              borderTopRightRadius: '0',
              borderBottomRightRadius: '0',
            },
          }}
        >
          <Box flex='0 0 25%'>
            <Box>
              <Box>
                <Typography variant='h1' fontFamily='Raleway,sans-serif' mb='0.625rem'>
                  Choose a destination
                </Typography>
              </Box>

              {data?.map((item) => {
                return (
                  item.isName && (
                    <Box key={item.index}>
                      <Button
                        disableRipple={true}
                        variant='text'
                        onClick={() => handleContinentClick(item)}
                        sx={{
                          bgcolor: item.index === currentIndex ? colors.basics.white : null,
                          color: item.index === currentIndex ? colors.basics.primary : '#303030',
                          '&:hover': {
                            color: colors.basics.primary,
                            bgcolor: item.index === currentIndex ? colors.basics.white : null,
                          },
                        }}
                      >
                        {item.name}
                      </Button>
                    </Box>
                  )
                );
              })}
            </Box>
          </Box>

          {data?.map((item: any) => (
            <Box key={item.index} flex='0 0 75%' display={item.index === currentIndex ? 'block' : 'none'}>
              {item.index === currentIndex && <Box height='100%'>{item.component}</Box>}
            </Box>
          ))}
        </Box>
      </MenuOverlay>
    </>
  );
};
